import styled from 'styled-components';
import { Box, Text } from 'pcln-design-system';
export const ListingCardWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HotlListingCardstyles__ListingCardWrapper",
  componentId: "sc-1ai2l6s-0"
})(["background-color:#fff;cursor:pointer;"]);
export const Img = /*#__PURE__*/styled.img.withConfig({
  displayName: "HotlListingCardstyles__Img",
  componentId: "sc-1ai2l6s-1"
})(["object-fit:cover;height:153px;width:100%;border-top-left-radius:16px;border-top-right-radius:16px;"]);
export const PriceCurrency = /*#__PURE__*/styled(Text.span).withConfig({
  displayName: "HotlListingCardstyles__PriceCurrency",
  componentId: "sc-1ai2l6s-2"
})(["vertical-align:super;position:relative;top:-2px;margin-right:2px;"]);
export const PriceCurrencyStrikeThrough = /*#__PURE__*/styled(PriceCurrency).withConfig({
  displayName: "HotlListingCardstyles__PriceCurrencyStrikeThrough",
  componentId: "sc-1ai2l6s-3"
})(["top:1px;"]);
export const TextStrikeThrough = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotlListingCardstyles__TextStrikeThrough",
  componentId: "sc-1ai2l6s-4"
})(["& ::before{content:'';width:40%;position:absolute;right:0px;top:14px;border-bottom:2px solid rgb(79,111,143);transform:skewY(-13deg);}"]);